<template>
  <div class="page-content">
    <div class="page-title">
      <h5>学位论文</h5>
    </div>
    
    <!-- 批次选择器 - 始终显示，让用户可以切换批次 -->
    <div class="panel" v-if="configs && configs.length">
      <table width="100%" cellpadding="5" border="0" class="tm_table_form">
        <tbody>
          <tr>
            <th style="width: 200px">批次 :</th>
            <td>
              <el-select size="mini" v-model="defaultThesisBatchId" @change="getInfo">
                <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- 未缴费提示 -->
    <template v-if="thesis && thesis.isPaid != 1">
      <div class="panel">
        <div style="font-weight: bold; text-align: center; color: red; padding: 40px; font-size: 16px;">
          当前批次未缴费，需要先缴费才能继续操作，请联系管理人员！
        </div>
        <!-- <div style="text-align: center; padding: 20px">
          <el-button
            type="primary"
            size="mini"
            >点击缴费</el-button
          >
        </div> -->
      </div>
    </template>

    <!-- 已缴费时显示正常内容 -->
    <template v-else-if="thesis && thesis.isPaid == 1">
      <div class="">
        <!-- <el-tabs class="panel " v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="学位申请" name="2"></el-tab-pane>
          <el-tab-pane label="学位论文" name="1"></el-tab-pane>
        </el-tabs> -->
      <div class="panel" v-if="activeName == 1">
        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
          <tbody>
            <template v-if="!config">
              <tr>
                <td colspan="2" style="font-weight: bold; text-align: center; color: red" id="no_thesis">
                  未发现毕业论文批次配置，请与主考学校联系。
                </td>
              </tr>
            </template>
            <template v-if="thesis && config">
              <tr>
                <th>审核时间 :</th>
                <td>{{ config.auditStartTime }}-{{ config.auditEndTime }}</td>
              </tr>
              <!-- <tr>
                <th>论文指导评审时间 :</th>
                <td>{{ config.examineStartDate }}-{{ config.examineEndDate }}</td>
              </tr>
              <tr>
                <th>状态 :</th>
                <td>
                  <template v-if="thesis.enrollStatus == 0">待审核</template>
                  <template v-if="thesis.enrollStatus == 1"><span style="color: red">打回修改</span></template>
                  <template v-if="thesis.enrollStatus == 2">通过</template>
                  <template v-if="thesis.enrollStatus == 4">待提交</template>
                  <template v-if="thesis.enrollStatus == 5">
                    <span style="color: red">不通过</span>
                  </template>
                </td>
              </tr>

              <tr>
                <th>主考学校 :</th>
                <td>{{ thesis.schoolCode }}-{{ thesis.schName }}</td>
              </tr> -->

              <tr>
                <th>状态 :</th>
                <td>
                  <template v-if="thesis.enrollStatus == 0">待审核</template>
                  <template v-if="thesis.enrollStatus == 1"><span style="color: red">打回修改</span></template>
                  <template v-if="thesis.enrollStatus == 2">通过</template>
                  <template v-if="thesis.enrollStatus == 4">待提交</template>
                  <template v-if="thesis.enrollStatus == 5">
                    <span style="color: red">不通过</span>
                  </template>
                </td>
              </tr>
              <tr>
                <th>申请表时间 :</th>
                <td>{{ config.applyFileStartTime }}-{{ config.applyFileEndTime }}</td>
              </tr>
              <tr v-if="thesis.applicationStatus != null">
                <th>申请表状态 :</th>
                <td>
                  <template v-if="thesis.applicationStatus == 0">待审核</template>
                  <template v-if="thesis.applicationStatus == 1">通过</template>
                  <template v-if="thesis.applicationStatus == 2"><span style="color: red">打回修改</span></template>
                </td>
              </tr>
              <tr v-if="thesis.enrollStatus == 2">
                <th>申请表 :</th>
                <td>
                  <!-- 在申请表提交时间内，允许填写和修改 -->
                  <el-button
                    v-if="isInApplyFileTime && (thesis.applicationStatus == null || thesis.applicationStatus == 2)"
                    type="primary"
                    size="mini"
                    @click="handleDegreeForm()"
                    >{{ thesis.applicationStatus == 2 ? '修改' : '填写' }}申请表</el-button>
                  
                  <!-- 只有申请表审核通过时才能查看 -->
                  <el-button
                    v-if="thesis.applicationStatus == 1"
                    type="primary"
                    size="mini"
                    @click="handleDegreeForm()"
                    >查看申请表</el-button>
                  
                  <!-- 时间提示 -->
                  <div v-if="!isInApplyFileTime && thesis.applicationStatus != 1" style="color: red; font-size: 12px;">
                    不在申请表提交时间范围内
                  </div>
                </td>
              </tr>

              <!-- <tr>
                <th>指导老师 :</th>
                <td>
                  <template v-if="thesis.teacherName">{{
                    thesis.teacherName
                  }}</template>
                  <template v-if="!thesis.teacherName">
                    <i>未指定</i>
                  </template>
                </td>
              </tr> -->
              <tr>
                <th>专业 :</th>
                <td>{{ thesis.specialtyCode }}-{{ thesis.specialtyName }}</td>
              </tr>
              <template
                v-if="thesis.enrollStatus == 4 && $utils.toTime(config.auditEndTime) > curTime && $utils.toTime(config.auditStartTime) < curTime">
                <!-- <template>
                  <tr>
                    <th>论文标题 :</th>
                    <td>
                      <el-input size="mini" v-model="thesis.thesisDegreeName" name="name" id="name" class="tm_txts"
                        style="width: 400px" />
                      <span style="color: red">*</span>
                    </td>
                  </tr>
                </template> -->
                <tr>
                  <th style="width: 200px">毕业年月</th>
                  <td>
                    <el-date-picker
                      v-model="thesis.graduationDate"
                      type="date"
                      placeholder="选择日期"
                      size="mini"
                      class="tm_txts"
                      value-format="yyyy-MM-dd"
                      style="width: 400px">
                    </el-date-picker>
                  </td>
                </tr>
                <tr>
                  <th style="width: 200px">毕业证书编号</th>
                  <td>
                    <el-input placeholder="" v-model="thesis.graduationNo" size="small"></el-input>
                  </td>
                </tr>
                <tr>
                  <th>论文原文 :</th>
                  <td>
                    <template v-if="thesis.thesisDegreeUrl">
                      <span id="chugaoInfo">
                        <a :href="thesis.thesisDegreeUrl" target="_blank">{{
                          thesis.thesisDegreeFileName
                        }}</a>（文件大小：{{ thesis.thesisDegreeSize }}）
                      </span>
                      <Upload style="display: none" @success="UploadChange($event, 'chugao')"
                        url="/student/thesis2/uploadFiles" accept=".doc,.docx,.pdf" id="btn_upload_chugao" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chugao')">重传</el-button>
                    </template>
                    <template v-else>
                      <Upload style="display: none" @success="UploadChange($event, 'chugao')"
                        url="/student/thesis2/uploadFiles" accept=".doc,.docx,.pdf" id="btn_upload_chugao" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chugao')">请上传</el-button>
                    </template>
                    <br />

                    <div style="color: red">
                      文件名格式：专业+准考证号+姓名，如：会计010615111345张三.doc
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>查重报告 :</th>
                  <td>
                    <template v-if="thesis.thesisAttUrl">
                      <div id="chugaoInfo" v-for="(e, i) in thesis.thesisAttUrl" :key="i">
                        <a :href="e" target="_blank">{{
                          thesis.thesisAttFileName[i]
                        }}</a>（文件大小：{{ thesis.thesisDegreeAttSize[i] }}）
                        <i class="el-icon-delete" style="color: red;cursor: pointer;" @click="delthesisAtt(i)"></i>
                      </div>
                      <!-- <Upload style="display: none" @success="UploadChange($event, 'chongchuan')"
                        url="/student/thesis2/uploadAttFiles" accept=".doc,.docx" id="btn_upload_chongchuan" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chongchuan')">重传</el-button> -->
                    </template>
                    <template>
                      <Upload style="display: none" @success="UploadChange($event, 'chongchuan')"
                        url="/student/thesis2/uploadAttFiles" accept=".doc,.docx,.pdf" id="btn_upload_chongchuan" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chongchuan')">请上传</el-button>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th>论文过程管理材料 :</th>
                  <td>
                    <template v-if="thesis.processMaterialsUrl">
                      <span id="processInfo">
                        <a :href="thesis.processMaterialsUrl" target="_blank">{{
                          thesis.processFileName
                        }}</a>（文件大小：{{ thesis.processShowSize }}）
                      </span>
                      <Upload style="display: none" @success="UploadChange($event, 'process')"
                        url="/student/thesis2/uploadAttFiles" accept=".doc,.docx,.pdf" id="btn_upload_process" />
                      <el-button type="primary" size="mini" @click="beforeUpload('process')">重传</el-button>
                    </template>
                    <template v-else>
                      <Upload style="display: none" @success="UploadChange($event, 'process')"
                        url="/student/thesis2/uploadAttFiles" accept=".doc,.docx,.pdf" id="btn_upload_process" />
                      <el-button type="primary" size="mini" @click="beforeUpload('process')">请上传</el-button>
                    </template>
                  </td>
                </tr>
                <!-- <tr>
                  <th style="width: 200px">备注</th>
                  <td>
                    <el-input type="textarea" :rows="4" placeholder="" v-model="thesis.thesisDegreeRemark">
                    </el-input>
                  </td>
                </tr> -->
                <template>
                  <tr>
                    <th>操作 :</th>
                    <td>
                      <el-button size="mini" class="send" type="primary" @click="toSubmit">
                        提交
                      </el-button>
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <!-- <tr>
                  <th>论文标题 :</th>
                  <td>{{ thesis.thesisDegreeName }}</td>
                </tr> -->
                <tr>
                  <th style="width: 200px">毕业年月</th>
                  <td>
                    <span>{{ thesis.graduationDate }}</span>
                  </td>
                </tr>
                <tr>
                  <th style="width: 200px">毕业证书编号</th>
                  <td>
                    <span>{{ thesis.graduationNo }}</span>
                  </td>
                </tr>

                <tr>
                  <th>论文附件 :</th>
                  <td>
                    <template v-if="thesis.thesisDegreeUrl">
                      <a :href="thesis.thesisDegreeUrl" target="_blank">{{
                        thesis.thesisDegreeFileName
                      }}</a>（文件大小：{{ thesis.thesisDegreeSize }}）

                    </template>
                    <template v-else>
                      <span style="color: red">未上传</span>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th>查重报告 :</th>
                  <td>
                    <template v-if="thesis.thesisAttUrl && thesis.thesisAttUrl.length">
                      <div id="chugaoInfo" v-for="(e, i) in thesis.thesisAttUrl" :key="i">
                        <a :href="e" target="_blank">{{
                          thesis.thesisAttFileName[i]
                        }}</a>（文件大小：{{ thesis.thesisDegreeAttSize[i] }}）
                      </div>
                    </template>
                    <template v-else>
                      <span style="color: red">未上传</span>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th>论文过程管理材料 :</th>
                  <td>
                    <template v-if="thesis.processMaterialsUrl">
                      <a :href="thesis.processMaterialsUrl" target="_blank">{{
                        thesis.processFileName
                      }}</a>（文件大小：{{ thesis.processSize }}）

                    </template>
                    <template v-else>
                      <span style="color: red">未上传</span>
                    </template>
                  </td>
                </tr>
                <!-- <tr>
                  <th style="width: 200px">备注</th>
                  <td>
                    {{ thesis.thesisDegreeRemark }}
                  </td>
                </tr> -->
              </template>
            </template>
            <template v-if="thesis == null && bm == null">
              <tr>
                <td colspan="2" style="font-weight: bold; text-align: center; color: red" id="no_thesis">
                  未发现毕业论文报名记录，请与主考学校联系。
                </td>
              </tr>
            </template>

          </tbody>
        </table>

        <template v-if="logs && logs.length">
          <div style="margin-top: 20px; font-size: 15px; text-align: left">
            日志记录：
            <hr width="80%" style="margin-left: 0px" />
          </div>
          <div style="border-bottom: 1px dashed #babec7; margin-top: 10px" v-for="(e, i) in logs" :key="i">
            <table class="tm_table_form">
              <tbody>
                <tr>
                  <th style="width: 200px">操作人</th>
                  <td>{{ e.userName }}</td>
                  <th style="width: 200px">操作时间</th>
                  <td>{{ e.operTime | dateFormat }}</td>
                </tr>
                <tr>
                  <th>操作描述</th>
                  <td colspan="3">
                    {{ e.operDesc }}

                  </td>
                </tr>
                <tr v-if="e.operRemark">
                  <th>{{ e.operType == "audit" || e.operType == "checkAuditing" ? "审核意见" : "备注" }}</th>
                  <td colspan="3">
                    <pre>{{ e.operRemark }}</pre>
                  </td>
                </tr>
                <tr v-if="e.attPath">
                  <th>文件</th>
                  <td colspan="3">
                    <a :href="e.attPath" target="_blank">{{ e.atname }}</a>
                    （文件大小：{{ e.attShowSize }}）
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>

      <div class="panel" v-if="activeName == 2">
        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
          <tbody>
            <template v-if="configs">
              <tr>
                <th style="width: 200px">批次 :</th>
                <td>
                  <el-select size="mini" v-model="defaultThesisBatchId" @change="getInfo">
                    <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </td>
              </tr>
            </template>

            <template v-if="!config">
              <tr>
                <td colspan="2" style="font-weight: bold; text-align: center; color: red" id="no_thesis">
                  未发现学位批次配置，请与主考学校联系。
                </td>
              </tr>
            </template>
            <tr v-if="degree&&degree.id">
                <th>状态 :</th>
                <td>
                  {{ statusMap[+degree.status] }}
                </td>
              </tr>
              <tr v-if="degree&&degree.remark">
                <th>审核备注 :</th>
                <td>
                  {{ degree.remark }}
                </td>
              </tr>
              <!-- 在申请时间范围内，论文报名了，学位提交过是打回修改的或者学位没有提交过 -->
            <template v-if="config&&$utils.toTime(config.applyEndTime) > curTime && $utils.toTime(config.applyStartTime) < curTime&&(thesis&&thesis.id&&(degree&&degree.id&&degree.status==2||!(degree&&degree.id)))">
              <tr>
                <th><span style="color: red" >*</span>入学时间 :</th>
                <td>
                    <el-date-picker
                      v-model="degree.enrolTime"
                      type="date"
                      placeholder="选择日期"
                      size="mini"
                      class="tm_txts"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 400px">
                    </el-date-picker>
                  
                </td>
              </tr>
              <tr>
                <th><span style="color: red" v-if="config.needIdCard">*</span>身份证正面 :</th>
                <td>
                  <UploadImage  v-model="degree.idCardA" />
                </td>
              </tr>
              <tr>
                <th><span style="color: red" v-if="config.needIdCard">*</span>身份证反面 :</th>
                <td>
                  <UploadImage  v-model="degree.idCardB" />
                </td>
              </tr>
              <tr>
                <th><span style="color: red" v-if="config.needDiploma">*</span>毕业证 :</th>
                <td>
                  <UploadImage  v-model="degree.diploma" />
                </td>
              </tr>
              <tr>
                <th><span style="color: red" v-if="config.needDegree">*</span>学位证 :</th>
                <td>
                  <UploadImage  v-model="degree.degree" />
                </td>
              </tr>
              <tr>
                <th style="width: 200px"><span style="color: red" v-if="config.needSchoolAward">*</span>在校期间奖励：</th>
                <td>
                  <el-input type="textarea" :rows="4" placeholder="" v-model="degree.schoolAward">
                  </el-input>
                </td>
              </tr>
              <tr>
                <th style="width: 200px"><span style="color: red" v-if="config.needSchoolPunish">*</span>在校期间处分：</th>
                <td>
                  <el-input type="textarea" :rows="4" placeholder="" v-model="degree.schoolPunish">
                  </el-input>
                </td>
              </tr>
              <tr>
                <th>操作 :</th>
                <td>
                  <el-button size="mini" class="send" type="primary" @click="degreeSubmit">
                    提交
                  </el-button>
                </td>
              </tr>

            </template>
             <template v-if="degree&&degree.id&&degree.status!=2">
              <tr>
                <th>入学时间 :</th>
                <td>
                    {{degree.enrolTime}}
                </td>
              </tr>
              <tr>
                <th>身份证正面 :</th>
                <td>
                  <el-image class="avatar" fit="contain"  :src="degree.idCardA"  v-if="degree.idCardA" />
                </td>
              </tr>
              <tr>
                <th>身份证反面 :</th>
                <td>
                  <el-image class="avatar" fit="contain"  :src="degree.idCardB"  v-if="degree.idCardB" />
                </td>
              </tr>
              <tr>
                <th>毕业证 :</th>
                <td>
                  <el-image class="avatar" fit="contain"  :src="degree.diploma"  v-if="degree.diploma" />
                </td>
              </tr>
              <tr>
                <th>学位证 :</th>
                <td>
                  <el-image class="avatar" fit="contain"  :src="degree.degree"  v-if="degree.degree" />
                </td>
              </tr>
              <tr>
                <th style="width: 200px">在校期间奖励：</th>
                <td>
                  {{degree.schoolAward}}
                </td>
              </tr>
              <tr>
                <th style="width: 200px">在校期间处分：</th>
                <td>
                  {{degree.schoolPunish}}
                </td>
              </tr>

            </template>
          </tbody>
        </table>
      </div>
    </div>

    <RegisteredPayDialog ref="RegisteredPayDialog" @refresh="getInfo"></RegisteredPayDialog>
    <Notice ref="Notice" title="学位论文须知" />
    </template>
  </div>
</template>

<script>
export default {
  name: "MySpotCheck",
  components: {
    Notice: () => import("./Notice.vue"),
    RegisteredPayDialog: () => import("./RegisteredPayDialog.vue"),
    UploadImage: () => import("@/components/UploadImage.vue"),
  },
  data() {
    return {
      activeName: "1",
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      logs: [],
      bm: null,
      curTime: new Date().getTime(),
      nowDate: new Date().getTime(),
      form: {},
      submitToAudit: {
        attPath: "",
        attSize: "",
        atname: "",
        remark: "",
        thesisId: "",
        operType: 1,
      },

      dialogFormVisible: false,



      degree:{},
      statusMap: {
        '0': "待审核",
        '1': "通过",
        '2': "打回修改",
        '-1': "驳回",
      },

      applyForm: {
        admissionYear: "",
        graduationYear: "",
        studyYears: "",
        studentNumber: "",
        examAvgScore: "",
        degreeType: "",
        thesisType: "",
        advisorName: "",
        thesisTitle: "",
        thesisKeywords: "",
        researchDirection: "",
        thesisGuideType: "",
        thesisTopicSource: "",
        thesisOrDesign: "",
        admissionImg: "",
        idCardImg: "",
        graduationCertImg: "",
        transcriptImg: "",
      },
      // applyForm: {
      //   "admissionYear": "2025-12-01",
      //   "studyYears": "2",
      //   "examAvgScore": "81",
      //   "degreeType": "继续教育",
      //   "thesisType": "毕业设计",
      //   "advisorName": "导师姓名",
      //   "thesisTitle": "论文题目",
      //   "thesisKeywords": "论文关键词",
      //   "researchDirection": "论文研究方向",
      //   "thesisGuideType": "英文",
      //   "thesisTopicSource": "国家社科规划、基金项目",
      //   "thesisOrDesign": "88",
      //   "admissionImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/3481E4AA7235436BA1689B0D468EDA56.jpeg",
      //   "idCardImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/284661FD4C484F1DAFD6354CFCD3FD1C.png",
      //   "graduationCertImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/D24223033EFE4F82A138323D3EEB17EC.jpeg",
      //   "transcriptImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/00D24A29D88A49F9A020EE9030DA390E.png"
      // },
      rules: {
        thesisBatchId: [{ required: true, message: "请输入论文批次ID", trigger: "blur" }],
        admissionYear: [{ required: true, message: "请输入有效的入学年月", trigger: "change" }],
        graduationYear: [{ required: true, message: "请输入有效的毕业年月", trigger: "blur" }],
        studyYears: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的修学年限", trigger: "blur" }],
        studentNumber: [{ required: true, message: "请输入学历证书编号", trigger: "blur" }],
        examAvgScore: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的考试课程平均成绩", trigger: "blur" }],
        degreeType: [{ required: true, message: "请选择学位类型", trigger: "change" }],
        thesisType: [{ required: true, message: "请选择论文类型", trigger: "change" }],
        advisorName: [{ required: true, message: "请输入导师姓名", trigger: "blur" }],
        thesisTitle: [{ required: true, message: "请输入论文题目", trigger: "blur" }],
        thesisKeywords: [{ required: true, message: "请输入论文关键词", trigger: "blur" }],
        researchDirection: [{ required: true, message: "请输入论文研究方向", trigger: "blur" }],
        thesisGuideType: [{ required: true, message: "请选择论文指导种类", trigger: "change" }],
        thesisTopicSource: [{ required: true, message: "请选择论文选题来源", trigger: "change" }],
        thesisOrDesign: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的毕业论文成绩", trigger: "blur" }],
        admissionImg: [{ required: true, message: "请上传身份证人像面", trigger: "blur" }],
        idCardImg: [{ required: true, message: "请上传身份证国徽面", trigger: "blur" }],
        graduationCertImg: [{ required: true, message: "请上传毕业证书", trigger: "blur" }],
        transcriptImg: [{ required: true, message: "请上传学籍表", trigger: "blur" }]
      }
    };
  },
  computed: {
    // 判断是否在申请表提交时间内
    isInApplyFileTime() {
      if (!this.config || !this.config.applyFileStartTime || !this.config.applyFileEndTime) {
        return false;
      }
      const now = new Date().getTime();
      const startTime = this.$utils.toTime(this.config.applyFileStartTime);
      const endTime = this.$utils.toTime(this.config.applyFileEndTime);
      return now >= startTime && now <= endTime;
    }
  },
  created() {
    if (this.$route.query.thesisBatchId) this.defaultThesisBatchId = +this.$route.query.thesisBatchId;
    this.getInfo();
  },
  beforeDestroy() {
  },
  methods: {
    handleDegreeForm() {
      // 如果申请表已审核通过，允许查看
      if (this.thesis.applicationStatus === 1) {
        this.$router.push({
          path: "/main/degreeForm",
          query: { 
            thesisBatchId: this.defaultThesisBatchId,
            mode: 'view'
          },
        });
        return;
      }
      
      // 检查是否在申请表提交时间内
      if (!this.isInApplyFileTime) {
        this.$message({
          showClose: true,
          message: `申请表提交时间为：${this.config.applyFileStartTime} 至 ${this.config.applyFileEndTime}，当前不在提交时间范围内`,
          type: "warning",
        });
        return;
      }
      
      // 在提交时间内，允许填写或修改
      this.$router.push({
        path: "/main/degreeForm",
        query: { 
          thesisBatchId: this.defaultThesisBatchId,
          mode: 'edit'
        },
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单提交", this.applyForm);

          const params = {
            ...this.applyForm,
            thesisBatchId: this.defaultThesisBatchId,
          }
          this.$http
          .post("/student/thesis/degree/application/submit", params)
          .then(res => {
            this.$message.success("上传成功");
            this.getInfo();
          });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    openFile(item) {
      const a = document.createElement("a");
      a.href = item.attPath;
      a.target = "_blank";
      a.download =
        "https://view.officeapps.live.com/op/view.aspx?src=" + item.atname;
      a.style.display = "none";
      document.body.append(a);
      a.click();
      document.body.removeChild(a); // 移除
    },
    upload() {
      //模拟点击上传图片
      document.getElementById("fileBtn").click();
    },
    uploadFn() {
      var fileName = this.$refs.file.files[0].name;
      var suffix = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
      if (
        !(
          suffix == ".doc" ||
          suffix == ".docx" ||
          suffix == ".pdf" ||
          suffix == ".xls" ||
          suffix == ".xlsx"
        )
      ) {
        this.$message.error("文件格式不正确");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      formData.append("thesisId", this.thesis.id);
      this.UploadChange_other(formData);
    },
    UploadChange_other(formData) {
      var that = this;
      that.$http
        .post("/student/thesis2/uploadAtt2", formData, {
          "Content-Type": "multipart/form-data",
        })
        .then(res => {
          this.$message.success("上传成功");
          this.getInfo();
        });
    },
    getInfo() {
      this.$http
        .post("/student/degree/myThesis", { thesisBatchId: this.defaultThesisBatchId })
        .then(res => {
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId) this.defaultThesisBatchId = res.defaultThesisBatchId;

          // this.getApply()

          this.thesis = res.thesis;
          this.bm = res.bm;
          if (res.thesis.attList) {
            this.thesis.thesisAttUrl = res.thesis.attList.map(e => e.thesisAttUrl)
            this.thesis.thesisDegreeAttSize = res.thesis.attList.map(e => e.thesisAttSize)
            this.thesis.thesisAttFileName = res.thesis.attList.map(e => e.thesisAttFileName)

            // this.thesis.processMaterialsUrl = res.thesis.attList.map(e => e.processMaterialsUrl)
          }
          this.handleClick()
          this.$http
            .get("/student/degree/log/detail/" + res.thesis.thesisDegreeEnrollId)
            .then(res => {
              this.logs = res.logs;
            });
        });
    },
    getApply() {
      this.$http.get("/student/thesis/degree/application/detail", { thesisBatchId: this.defaultThesisBatchId }).then(res => {
        this.applyForm = res
      })
    },
    gonggao(n) {
      const u_id = this.$store.state.user.userId + "3";
      if (!sessionStorage.getItem(u_id) && n) {
        this.$refs.Notice.open(n, () => {
          sessionStorage.setItem(u_id, "1");
        });

      }
    },
    //上传
    UploadChange(e, t) {
      const _t = this;
      if (t == "chugao") {
        this.thesis.thesisDegreeUrl = e.fullpath;
        this.thesis.attSize = e.fileSize;
        this.thesis.thesisDegreeSize = e.fileShowSize;
        this.thesis.thesisDegreeFileName = e.filename;
      } else if (t == "chongchuan") {
        if (this.thesis.thesisAttUrl) {
          this.thesis.thesisAttUrl.push(e.fullpath)
          this.thesis.thesisDegreeAttSize.push(e.fileShowSize)
          this.thesis.thesisAttFileName.push(e.filename)
        } else {
          this.thesis.thesisAttUrl = [e.fullpath]
          this.thesis.thesisDegreeAttSize = [e.fileShowSize]
          this.thesis.thesisAttFileName = [e.filename]
        }
      } else if (t == "process") {
        this.thesis.processMaterialsUrl = e.fullpath;
        this.thesis.processSize = e.fileSize;
        this.thesis.processShowSize = e.fileShowSize;
        this.thesis.processFileName = e.filename;
        // this.thesis.processFileName = '论文过程管理材料';
      }
      this.$forceUpdate()
    },
    beforeUpload(t) {
      if (t == "chugao") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "chongchuan") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "process") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
    },
    delthesisAtt(i) {
      this.thesis.thesisAttUrl.splice(i, 1)
      this.thesis.thesisDegreeAttSize.splice(i, 1)
      this.thesis.thesisAttFileName.splice(i, 1)
      this.$forceUpdate()
    },
    // submitToAuditb() {
    //   const params = {
    //     thesisId: this.thesis.id,
    //     name: this.thesis.name,
    //     email: this.thesis.email,
    //     attPath: this.submitToAudit.attPath,
    //     attSize: this.submitToAudit.attSize,
    //     remark: this.submitToAudit.remark,
    //   };
    //   if (!params.attPath) {
    //     this.$message({
    //       showClose: true,
    //       message: "请先上传最新版论文后再操作！",
    //       type: "error",
    //     });
    //     return;
    //   }
    //   const _t = this;
    //   _t.$http.post("/student/thesis2/submitToAudit", params).then(res => {
    //     if (res) {
    //       this.$message({
    //         showClose: true,
    //         message: "提交成功，等待指导老师审核。",
    //         type: "success",
    //       });
    //       _t.getInfo();
    //     }
    //   });

    // },

    toSubmit() {
      const _t = this,
        thesis = this.thesis;
        if (!thesis.graduationDate || !thesis.graduationNo) {
          this.$message({
            showClose: true,
            message: "请先完善信息",
            type: "error",
          });
          return;
        }
      if (!thesis.thesisDegreeUrl) {
        this.$message({
          showClose: true,
          message: "请先上传论文后再操作！",
          type: "error",
        });
        return;
      }
      if (!thesis.thesisAttUrl || !thesis.thesisAttUrl.length) {
        this.$message({
          showClose: true,
          message: "请先上传查重报告后再操作！",
          type: "error",
        });
        return;
      }
      if (!thesis.processMaterialsUrl) {
        this.$message({
          showClose: true,
          message: "请先上传论文过程管理材料后再操作！",
          type: "error",
        });
        return;
      }

      const params = {
        thesisDegreeBatchId: _t.config.id,
        thesisDegreeName: _t.thesis.thesisDegreeName,
        thesisDegreeUrl: _t.thesis.thesisDegreeUrl,
        thesisDegreeFileName: _t.thesis.thesisDegreeFileName,
        thesisDegreeSize: _t.thesis.thesisDegreeSize,
        thesisAttUrl: _t.thesis.thesisAttUrl,
        thesisAttFileName: _t.thesis.thesisAttFileName,
        thesisDegreeAttSize: _t.thesis.thesisDegreeAttSize,
        thesisDegreeRemark: _t.thesis.thesisDegreeRemark,

        graduationDate: _t.thesis.graduationDate,
        graduationNo: _t.thesis.graduationNo,
        processMaterialsUrl: _t.thesis.processMaterialsUrl,
        processFileName: _t.thesis.processFileName,
        processSize: _t.thesis.processSize,
      };

      this.$confirm("是否确定提交给老师审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _t.$http
            .post("/student/degree/submit", params)
            .then(res => {
              if (res) {
                this.$message({
                  showClose: true,
                  message: "提交成功，等待指导老师审核。",
                  type: "success",
                });
                _t.getInfo();
              }
            });
        })
        .catch(() => { });
    },
    uploadAtt2() { },
    toUploadAtt() {
      this.$confirm("重新上传将会覆盖现有论文，是否继续！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          document
            .getElementById("btn_uploadAtt")
            .getElementsByClassName("el-upload__input")[0]
            .click();
        })
        .catch(() => { });
    },


    handleClick(tab, event) {
      if(this.activeName==2){
        this.degree={}
        this.$http
        .get("/student/degreeApply", { batchId: this.defaultThesisBatchId })
        .then(res => {
          if(res&&res.length>0){
            this.degree = res[0]
          }
        });
      }
      
    },
    degreeSubmit(){
      const _this=this
      if (!this.degree.enrolTime) {
        this.$message({
          showClose: true,
          message: "请先选择入学时间后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needIdCard&&!this.degree.idCardA) {
        this.$message({
          showClose: true,
          message: "请先上传身份证正面后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needIdCard&&!this.degree.idCardB) {
        this.$message({
          showClose: true,
          message: "请先上传身份证反面后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needDiploma&&!this.degree.diploma) {
        this.$message({
          showClose: true,
          message: "请先上传毕业证后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needDegree&&!this.degree.degree) {
        this.$message({
          showClose: true,
          message: "请先上传学位证后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needSchoolAward&&!this.degree.schoolAward) {
        this.$message({
          showClose: true,
          message: "请先输入在校期间奖励后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needSchoolPunish&&!this.degree.schoolPunish) {
        this.$message({
          showClose: true,
          message: "请先输入在校期间处分后再操作！",
          type: "error",
        });
        return;
      }
      this.$http
            .post("/student/degreeApply", {...this.degree,batchId:this.defaultThesisBatchId})
            .then(res => {
              console.log(res);
              
                _this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: "success",
                });
                _this.getInfo();
            });
        
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/variable.scss";
.tm_required {
  color: #f00;
  margin-left: 10px;
}

.editPhone .el-input {
  width: 250px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.title {
  position: relative;
  padding-left: 8px;

  &::before {
    content: "";
    position: absolute;
    width: 3px;
    height: 18px;
    background-color: $primary;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
